import { toast } from 'react-toastify'
import { validateVatNumber } from '../services/micro'
import { getPublisher } from '../services/pub'
import getAllCountires from '../services/adv/get_all_countires'
import { isCookiesEnabled } from '../contexts/CookiesContext'
import Cookies from 'universal-cookie'
import { cookiesKeyNames } from '@revbox/common-fe'

const RECURRING_INTERVALS_VALIDATION = {
    // Daily
    1: close_time => {
        const difference = close_time - Date.now()
        return difference > 24 * 60 * 60 * 1000
    },
    // Weekly
    2: close_time => {
        const difference = close_time - Date.now()
        return difference > 7 * 24 * 60 * 60 * 1000
    },
    // Monthly
    3: close_time => {
        const difference = close_time - Date.now()
        return difference > 30 * 24 * 60 * 60 * 1000
    }
}

export default async function validateForRequired(tableStructure, newRecord, isManualTransactionCreation, isBalanceCreation) {
    const cookies = new Cookies()
    const validationResults = {}

    const excludedColumns = [
        'user_email',
        'first_name',
        'last_name',
        'invoice_account_name',
        'invoice_address',
        'invoice_street',
        'invoice_city',
        'invoice_address_zip_code',
        'invoice_address_state',
        'invoice_address_country_id',
        'vat_number',
        'transaction_type_id',
        'transaction_status_id'
    ]

    await Promise.all(
        tableStructure.columns.map(async column => {
            if (isManualTransactionCreation && excludedColumns.includes(column.name)) {
                return
            }

            if (isBalanceCreation && excludedColumns.includes(column.name)) {
                return
            }

            if (
                column.is_required &&
                (newRecord[column.name] === undefined ||
                    newRecord[column.name] === null ||
                    newRecord[column.name] === 0 ||
                    newRecord[column.name] === '')
            ) {
                toast.error(`Error while creating record: ${column.title} is required!`)
                validationResults[column.name] = false
            } else {
                validationResults[column.name] = true
            }

            if (column.name === 'vat_number' || column.name === 'billing_vat_number') {
                if (!newRecord[column.name]) {
                    validationResults[column.name] = true
                    return
                }

                if (newRecord[column.name].trim().length === 0) {
                    validationResults[column.name] = true
                    return
                }

                const publisherIdByCookies = isCookiesEnabled
                    ? cookies.get(cookiesKeyNames.publisherId)
                    : localStorage.getItem(cookiesKeyNames.publisherId)

                const publisher = await getPublisher(publisherIdByCookies)
                const countries = await getAllCountires()

                const country = countries?.data?.find(country => country.id === publisher?.data?.country_id)

                if (!country) {
                    validationResults[column.name] = false
                    return
                }

                const vatValidation = await validateVatNumber({ countryCode: country?.code, vatNumber: newRecord[column.name] })

                if (vatValidation?.data?.isVatValid) {
                    validationResults[column.name] = true
                } else {
                    validationResults[column.name] = false
                }
            }

            if (column.name === 'close_time' && [6,8,9].includes(newRecord['inventory_type'])) {
                const close_time = new Date(newRecord[column.name]).getTime()
                const recurring_interval = newRecord['recurring_interval']

                if (!close_time) {
                    validationResults[column.name] = false
                    return
                }

                if (close_time < Date.now()) {
                    validationResults[column.name] = false
                } else {
                    validationResults[column.name] = true
                }

                // if (recurring_interval) {
                //     if (RECURRING_INTERVALS_VALIDATION[recurring_interval](close_time)) {
                //         validationResults[column.name] = true
                //     } else {
                //         validationResults[column.name] = false
                //     }
                // }
            }
        })
    )

    return validationResults
}
